var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"event-type",class:{ sm: _vm.$mq === 'sm' }},[_vm._v(" "+_vm._s(_vm.event.event_type)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }